export default function HowToOpenSpinner() {
  return (
    <section className="py-16 md:py-24 bg-[#f0f4f7]">
      <div className="container-main">
        <div className="text-center mb-10 md:mb-12">
          <span className="text-xs font-semibold uppercase tracking-wider text-[#4f528d]">
            Quick Guide
          </span>
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-[#1A1A1A] mt-3">
            How to Open a Spinner
          </h2>
          <p className="text-[#8B7355] text-base md:text-lg mt-3 max-w-xl mx-auto">
            Watch this short video to learn the easiest way to open your new wind spinner.
          </p>
        </div>

        <div className="max-w-4xl mx-auto rounded-2xl overflow-hidden border border-[#E8E0D4] bg-white shadow-sm">
          <div className="relative w-full aspect-video">
            <iframe
              className="absolute inset-0 w-full h-full"
              src="https://www.youtube.com/embed/z38pIrgwKSM"
              title="How to Open a Spinner"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}